/*
  GK Member v2. Jembatan antara job portal (getkarier.com) dan Member Portal (app.getkarier.com).
  Session Supabase dibaca dari cookie ber-domain .getkarier.com yang di-set portal saat login.
  Fitur: simpan/hapus lowongan (saved_jobs) + catat klik Lamar (apply_clicks), dua-duanya
  lewat REST Supabase dengan RLS per user. Kalau token kedaluwarsa, di-refresh di sini
  dan cookie ditulis balik supaya portal ikut kebagian session barunya.
  Juga menyalakan avatar + dropdown akun di header (initAccountLinks) dan logout lintas domain.
  Konfigurasi: window.GK_MEMBER_CONF = { url, anonKey, portalUrl } (di-set section pemanggil).

  v2 (2026-07-13): label trigger dipakai nama depan user, bukan kata "Akun". Daftar link
  dropdown akun sekarang dirender dari MENU di bawah, jadi rute portal cuma hidup di satu
  tempat. Markup <a> di header.liquid / header-drawer.liquid tinggal fallback yang tidak
  pernah kelihatan (panel-nya hidden sampai JS jalan).

  v2.1 (2026-07-13): slot email dicari dari level wrap, bukan dari panel dropdown, supaya
  di drawer mobile email bisa duduk permanen di baris profil (di bawah nama) dan tidak ikut
  sembunyi waktu dropdown ditutup.

  v2.2 (2026-07-26): saldo Miles (Paspor Karier) di header, permukaan keempat. Ditambah
  api.rpc() + initMilesPill(). TIDAK ada endpoint portal ber-CORS yang dibuat untuk ini:
  cookie sesinya sudah terbaca di file ini, jadi saldonya diambil dari RPC gk_miles_state()
  langsung ke Supabase, persis seperti saved_jobs dan apply_clicks di bawah.

  v2.3 (2026-07-27): audit mobile header -- pil .gk-miles-pill sekarang cuma tampil di
  >=1025px (breakpoint yang sama dipakai portal & drawer mobile buat "desktop"), jadi
  HP tidak lagi memajang Miles di header. Gantinya, saldo dipindah ke baris baru di
  dalam dropdown akun (.gk-account-dropdown__miles, markup di header.liquid): Nama /
  Email / Icon+Miles / garis / Dashboard dst -- tampil di semua ukuran layar begitu
  profil diklik. initMilesPill() diganti nama jadi initMiles() karena sekarang mengisi
  DUA permukaan dari satu panggilan RPC, bukan cuma satu pil.

  v2.4 (2026-07-31): pil .gk-miles-pill dan MILES_CSS DICABUT seluruhnya
  (F-LP-18). Saldo tinggal di baris dropdown, formatnya jadi ala maskapai
  "635 Miles · Economy" (F-LP-18b) dengan nama level dari RPC gk_miles_level.
  Konstanta MENU disamakan dengan PORTAL_NAV di lib/nav.ts (F-LP-19): tambah
  Paspor Karier, dan CV Audit Credit jadi Top-Up Miles. Tambah initGuestOnly()
  untuk elemen yang cuma buat pengunjung belum login (F-JOB-02).
*/
(function (w, d) {
  'use strict';
  var CONF = w.GK_MEMBER_CONF || {};
  var BASE = CONF.url;
  var KEY = CONF.anonKey;
  var PORTAL = CONF.portalUrl || 'https://app.getkarier.com';
  // Project job portal. Terpisah dari BASE (member portal) dan memang harus
  // begitu: tabel lowongan dan RPC token Shopify ada di sini, akun member ada
  // di sana. Dipakai satu tempat saja, initVisaGate().
  var JOBS_BASE = CONF.jobsUrl || 'https://sftrxlriosixrryqcibx.supabase.co';
  if (!BASE || !KEY) return;
  var REF = BASE.replace(/^https?:\/\//, '').split('.')[0];
  var COOKIE = 'sb-' + REF + '-auth-token';
  var ATTRS = '; domain=.getkarier.com; path=/; max-age=31536000; secure; samesite=lax';
  var KILL = '; domain=.getkarier.com; path=/; max-age=0; secure; samesite=lax';

  // Satu-satunya sumber rute menu akun di storefront. Isinya harus sama dengan
  // PORTAL_NAV di lib/nav.ts (repo getkarier-portal).
  //
  // Kenapa disalin, bukan ditarik dari /api/cv-audit/session seperti CV Auditor
  // dan Career Map: dua tool itu tinggal satu origin dengan portal, jadi cookie
  // sesinya ikut terkirim sendiri. getkarier.com beda origin, dan endpoint itu
  // tidak melayani CORS. Konsekuensinya daftar ini bisa melenceng dari portal
  // tanpa ada yang error, jadi kalau PORTAL_NAV berubah, ubah juga di sini.
  //
  // ⚠ Catatan 'Top Up Review' yang dulu ada di sini SUDAH DICABUT 2026-08-09.
  // Item itu tidak ada lagi di MENU maupun di PORTAL_NAV, dan produknya sendiri
  // dihapus dari Shopify 2026-07-26. Komentarnya bertahan tiga minggu lebih lama
  // daripada barisnya, dan menyuruh sesi berikutnya merawat sesuatu yang sudah
  // tidak ada.
  //
  // 🔴 Daftar ini pernah tertinggal dari PORTAL_NAV selama sehari.
  // 'Riwayat Audit CV' masuk ke PORTAL_NAV 2026-08-08 dan tidak ikut ke sini,
  // jadi dropdown akun di storefront kehilangan satu item yang ada di portal.
  // Ditemukan 2026-08-09 lewat penyisiran komentar, bukan lewat keluhan.
  // Ini pola yang sama dengan MARKETING_NAV yang tertinggal lima hari.
  // Peringatan di atas jelas dan tetap tidak cukup, jadi jangan menambah
  // peringatan lagi: yang menahan cuma benar-benar membuka lib/nav.ts waktu
  // menyentuh berkas ini.
  // 🔴 26 Sep 2026 (audit menu): urutan DAN label disamakan persis dengan
  // PORTAL_NAV. Sebelumnya storefront memakai nama lama (Dashboard, Paspor
  // Karier, Riwayat Audit CV, Lamaran Kerja) sementara portal sudah memakai
  // Beranda, Paspor, Lamaran; satu halaman punya dua nama tergantung situs
  // mana yang sedang dibuka. "Riwayat Audit" (bukan "Audit CV") supaya tidak
  // bentrok dengan menu Audit CV di nav atas yang membuka ALATNYA.
  //
  // Riwayat baris ini: '/cv-audit#riwayat' sampai 9 Agustus 2026 (layar itu
  // sudah dicabut, klik mendarat di layar unggah); 'Riwayat pembelian' dicabut
  // 17 Sep (jadi tab di /products). 'Isi Miles' tetap di MENU tapi tidak
  // digambar renderMenu karena sudah jadi tombol di baris Miles.
  var MENU = [
    { label: 'Beranda', path: '/dashboard' },
    { label: 'Lamaran', path: '/jobs' },
    { label: 'Riwayat Audit', path: '/riwayat-cv' },
    { label: 'Isi Miles', path: '/topup' },
    { label: 'Produk & Pesanan', path: '/products' },
    { label: 'Paspor', path: '/paspor' },
    { label: 'Profil', path: '/profile' }
  ];

  function readCookies() {
    var out = {};
    var parts = d.cookie ? d.cookie.split('; ') : [];
    for (var i = 0; i < parts.length; i++) {
      var eq = parts[i].indexOf('=');
      if (eq < 0) continue;
      out[parts[i].slice(0, eq)] = parts[i].slice(eq + 1);
    }
    return out;
  }

  function readRaw() {
    var all = readCookies();
    if (all[COOKIE]) return decodeURIComponent(all[COOKIE]);
    var chunks = [];
    for (var i = 0; i < 10; i++) {
      var v = all[COOKIE + '.' + i];
      if (v === undefined) break;
      chunks.push(decodeURIComponent(v));
    }
    return chunks.length ? chunks.join('') : null;
  }

  function decodeSession(raw) {
    try {
      if (raw.indexOf('base64-') === 0) {
        var b64 = raw.slice(7).replace(/-/g, '+').replace(/_/g, '/');
        while (b64.length % 4) b64 += '=';
        var bin = atob(b64);
        try { raw = decodeURIComponent(escape(bin)); } catch (e) { raw = bin; }
      }
      var s = JSON.parse(raw);
      return s && s.access_token ? s : null;
    } catch (e) { return null; }
  }

  function writeSession(sess) {
    var json = JSON.stringify(sess);
    var b64 = btoa(unescape(encodeURIComponent(json)))
      .replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
    var raw = 'base64-' + b64;
    d.cookie = COOKIE + '=' + KILL;
    for (var i = 0; i < 10; i++) d.cookie = COOKIE + '.' + i + '=' + KILL;
    var LIMIT = 3180;
    if (raw.length <= LIMIT) {
      d.cookie = COOKIE + '=' + raw + ATTRS;
    } else {
      var n = 0;
      for (var p = 0; p < raw.length; p += LIMIT) {
        d.cookie = COOKIE + '.' + n + '=' + raw.slice(p, p + LIMIT) + ATTRS;
        n++;
      }
    }
  }

  function clearSessionCookie() {
    d.cookie = COOKIE + '=' + KILL;
    for (var i = 0; i < 10; i++) d.cookie = COOKIE + '.' + i + '=' + KILL;
  }

  var _session;
  function getSession() {
    if (_session) return _session;
    _session = new Promise(function (resolve) {
      var raw = readRaw();
      var sess = raw && decodeSession(raw);
      if (!sess) return resolve(null);
      var now = Math.floor(Date.now() / 1000);
      if (sess.expires_at && sess.expires_at - now > 60) return resolve(sess);
      if (!sess.refresh_token) return resolve(null);
      fetch(BASE + '/auth/v1/token?grant_type=refresh_token', {
        method: 'POST',
        headers: { apikey: KEY, 'Content-Type': 'application/json' },
        body: JSON.stringify({ refresh_token: sess.refresh_token })
      }).then(function (r) { return r.ok ? r.json() : null; })
        .then(function (fresh) {
          if (fresh && fresh.access_token) { writeSession(fresh); resolve(fresh); }
          else resolve(null);
        })
        .catch(function () { resolve(null); });
    });
    return _session;
  }

  function rest(sess, path, opts) {
    opts = opts || {};
    var headers = {
      apikey: KEY,
      Authorization: 'Bearer ' + sess.access_token,
      'Content-Type': 'application/json'
    };
    if (opts.headers) { for (var k in opts.headers) headers[k] = opts.headers[k]; }
    opts.headers = headers;
    return fetch(BASE + '/rest/v1/' + path, opts);
  }

  function logout() {
    return getSession().then(function (s) {
      var done = function () {
        clearSessionCookie();
        w.location.reload();
      };
      if (s && s.access_token) {
        return fetch(BASE + '/auth/v1/logout?scope=local', {
          method: 'POST',
          headers: { apikey: KEY, Authorization: 'Bearer ' + s.access_token }
        }).catch(function () {}).then(done);
      }
      done();
    });
  }

  var api = {
    getSession: getSession,
    loginUrl: function (next) {
      return PORTAL + '/?next=' + encodeURIComponent(next || w.location.href);
    },
    logout: logout,
    // RPC Supabase memakai token user yang sama dengan saved_jobs/apply_clicks.
    // Balasannya null kalau tidak ada sesi atau requestnya gagal, jadi pemanggil
    // cukup memeriksa null dan tidak perlu menangani error sendiri.
    rpc: function (name, args) {
      return getSession().then(function (s) {
        if (!s) return null;
        return rest(s, 'rpc/' + name, {
          method: 'POST',
          body: JSON.stringify(args || {})
        }).then(function (r) { return r.ok ? r.json() : null; });
      }).catch(function () { return null; });
    },
    isSaved: function (handle) {
      return getSession().then(function (s) {
        if (!s) return null;
        return rest(s, 'saved_jobs?select=id&job_handle=eq.' + encodeURIComponent(handle))
          .then(function (r) { return r.ok ? r.json() : []; })
          .then(function (rows) { return rows.length > 0; });
      });
    },
    save: function (job) {
      return getSession().then(function (s) {
        if (!s) return false;
        return rest(s, 'saved_jobs?on_conflict=user_id,job_handle', {
          method: 'POST',
          headers: { Prefer: 'resolution=ignore-duplicates' },
          body: JSON.stringify({
            job_handle: job.handle,
            job_title: job.title,
            company: job.company || null,
            country: job.country || null,
            job_url: job.url,
            apply_url: job.apply_url || null,
            visa_status: job.visa_status || null
          })
        }).then(function (r) { return r.ok; });
      });
    },
    unsave: function (handle) {
      return getSession().then(function (s) {
        if (!s) return false;
        return rest(s, 'saved_jobs?job_handle=eq.' + encodeURIComponent(handle), { method: 'DELETE' })
          .then(function (r) { return r.ok; });
      });
    },
    // Mencatat klik Lamar dengan sesi yang SUDAH dipegang pemanggil.
    //
    // Dipisah dari trackApply() waktu L4 dikerjakan, karena pemanggil di
    // halaman lowongan sekarang perlu tahu sendiri apakah ada sesi (untuk
    // memutuskan membuka kartu "sudah kirim lamarannya?"). Kalau dia memeriksa
    // sesi lalu trackApply() memeriksanya lagi, dua permintaan berangkat untuk
    // satu pertanyaan, dan yang kedua bisa menjawab beda kalau tokennya
    // kebetulan disegarkan di antaranya.
    trackApplyWithSession: function (s, job) {
      if (!s) return;
      rest(s, 'apply_clicks', {
        method: 'POST',
        keepalive: true,
        body: JSON.stringify({
          job_handle: job.handle,
          job_title: job.title,
          company: job.company || null,
          country: job.country || null,
          job_url: job.url,
          apply_url: job.apply_url || null
        })
      }).catch(function () {});
    },

    // Bentuk lama, dibiarkan hidup. Dia bagian dari w.gkMember, jadi bisa
    // dipanggil dari mana saja termasuk berkas yang tidak ada di repo ini.
    // Sekarang cuma pembungkus tipis di atas yang di atas.
    trackApply: function (job) {
      var self = this;
      getSession().then(function (s) {
        self.trackApplyWithSession(s, job);
      });
    }
  };
  w.gkMember = api;

  // Perbesar resolusi foto profil Google supaya tetap tajam walau container-nya kecil
  // (retina/HiDPI). URL Google Photos umumnya diakhiri "=s96-c" atau pakai query "sz=".
  function upsizeAvatar(url, size) {
    if (!url) return url;
    if (/=s\d+-c/.test(url)) return url.replace(/=s\d+-c/, '=s' + size + '-c');
    if (/[?&]sz=\d+/.test(url)) return url.replace(/([?&]sz=)\d+/, '$1' + size);
    return url;
  }

  // Header: avatar + dropdown akun. Elemen ditandai [data-gk-account-wrap] (bungkus),
  // di dalamnya ada [data-gk-account-link] (trigger <a>) + [data-gk-account-dropdown] (panel).
  function initAccountLinks() {
    var wraps = d.querySelectorAll('[data-gk-account-wrap]');
    if (!wraps.length) return;
    var here = w.location.href;
    var i;

    for (i = 0; i < wraps.length; i++) {
      var initLink = wraps[i].querySelector('[data-gk-account-link]');
      if (initLink) initLink.href = api.loginUrl(here);
      // Default status = tamu; dropdown Masuk/Daftar (item 2). applyLoggedIn
      // menaikkannya ke 'member' kalau ada sesi.
      if (!wraps[i].getAttribute('data-gk-state')) wraps[i].setAttribute('data-gk-state', 'guest');
      wireAccountToggle(wraps[i]);
    }

    getSession().then(function (s) {
      if (!s) {
        // Menutup lingkaran penanda dari <head> (audit UX nomor 12). Cookie
        // sesinya ada tapi ternyata tidak sah lagi -- biasanya refresh token
        // yang ditolak. Tanpa baris ini, CSS tetap menyembunyikan ikon tamu dan
        // orangnya melihat lingkaran kosong selamanya, yaitu keadaan yang tidak
        // berarti apa-apa buat siapa pun.
        d.documentElement.setAttribute('data-gk-sesi', '0');
        return;
      }
      var user = s.user || {};
      var meta = user.user_metadata || {};
      var name = meta.full_name || meta.name || (user.email ? user.email.split('@')[0] : 'Member');
      var avatarUrl = upsizeAvatar(meta.avatar_url || meta.picture || '', 128);
      var initial = name.charAt(0).toUpperCase();

      for (i = 0; i < wraps.length; i++) {
        applyLoggedIn(wraps[i], { name: name, email: user.email || '', avatarUrl: avatarUrl, initial: initial });
      }
    });
  }

  // Toggle dropdown akun. Panel yang tampil tergantung data-gk-state pada wrap:
  // 'guest'  -> [data-gk-account-guest] berisi Masuk / Daftar (item 2);
  // 'member' -> [data-gk-account-dropdown] berisi menu portal + Keluar.
  // Dipasang untuk SEMUA status (tamu maupun member) supaya applyLoggedIn tidak
  // perlu mewire ulang; ia cukup mengubah data-gk-state.
  function wireAccountToggle(wrap) {
    var link = wrap.querySelector('[data-gk-account-link]');
    if (!link || link.hasAttribute('data-gk-wired')) return;
    link.setAttribute('data-gk-wired', '1');
    link.addEventListener('click', function (evt) {
      evt.preventDefault();
      var isOpen = wrap.classList.toggle('is-open');
      var member = wrap.getAttribute('data-gk-state') === 'member';
      var mp = wrap.querySelector('[data-gk-account-dropdown]');
      var gp = wrap.querySelector('[data-gk-account-guest]');
      var showMember = isOpen && member;
      var showGuest = isOpen && !member;
      if (mp) { mp.hidden = !showMember; mp.setAttribute('aria-hidden', showMember ? 'false' : 'true'); }
      if (gp) { gp.hidden = !showGuest; gp.setAttribute('aria-hidden', showGuest ? 'false' : 'true'); }
    });
  }

  // ss20 (17 Sep 2026): tiap baris menu dapat ikon Lucide, dan '/topup' tidak
  // ikut digambar karena sudah jadi tombol "Isi Miles" di kartu Miles.
  // Path-nya sama dengan public/gk-akun-menu.js di repo portal, supaya menu
  // akun di storefront, Career Map, dan CV Auditor benar-benar sebentuk.
  // 25 Sep 2026: set gk-ikon (RENCANA ikon-situs-2026-09-25). Garis polos stroke 2; noda cat air
  // di belakang ikon DICABUT atas permintaan Rivaldy (theme 127). Path dari svg/buat_set.py.
  // ⚠ public/gk-akun-menu.js di repo portal masih memakai set lama sampai portal ikut dirakit.
  var IKON = {
    '/dashboard': '<rect x="3.5" y="3.5" width="7" height="8" rx="1.2"/><rect x="13.5" y="3.5" width="7" height="5" rx="1.2"/><rect x="13.5" y="11.5" width="7" height="9" rx="1.2"/><rect x="3.5" y="14.5" width="7" height="6" rx="1.2"/>',
    '/paspor': '<rect x="5" y="3" width="14" height="18" rx="2"/><circle cx="12" cy="10" r="3"/><path d="M9 10h6M12 7c.9.8 1.3 1.8 1.3 3s-.4 2.2-1.3 3M9 16.5h6"/>',
    '/products': '<path d="M12 3l8 4.5v9L12 21l-8-4.5v-9z"/><path d="M4 7.5l8 4.5 8-4.5M12 12v9"/>',
    '/riwayat-cv': '<path d="M14 3H6.5a1.5 1.5 0 0 0-1.5 1.5v15A1.5 1.5 0 0 0 6.5 21h11a1.5 1.5 0 0 0 1.5-1.5V8z"/><path d="M14 3v5h5M8.5 13h7M8.5 17h5"/>',
    '/jobs': '<rect x="3" y="5" width="18" height="14" rx="2"/><path d="M3.5 6.5l8.5 6.5 8.5-6.5"/>',
    '/profile': '<circle cx="12" cy="8" r="4"/><path d="M4 20c1.2-3.6 4.2-5.5 8-5.5s6.8 1.9 8 5.5"/>'
  };
  function ikonSvg(path) {
    var isi = IKON[path];
    if (!isi) return '';
    return '<svg class="gk-account-dropdown__ico" width="20" height="20" viewBox="0 0 24 24" fill="none" ' +
      'stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + isi + '</svg>';
  }

  // Render ulang daftar link di panel dari MENU, lalu sisipkan sebelum tombol Keluar.
  function renderMenu(panel) {
    var olds = panel.querySelectorAll('a.gk-account-dropdown__link');
    for (var i = 0; i < olds.length; i++) olds[i].parentNode.removeChild(olds[i]);

    var logoutBtn = panel.querySelector('[data-gk-logout]');
    for (var j = 0; j < MENU.length; j++) {
      if (MENU[j].path === '/topup') continue;
      var a = d.createElement('a');
      a.className = 'gk-account-dropdown__link';
      a.href = PORTAL + MENU[j].path;
      a.innerHTML = ikonSvg(MENU[j].path) + '<span>' + MENU[j].label + '</span>';
      if (logoutBtn) panel.insertBefore(a, logoutBtn);
      else panel.appendChild(a);
    }
  }

  function applyLoggedIn(wrap, u) {
    var link = wrap.querySelector('[data-gk-account-link]');
    var panel = wrap.querySelector('[data-gk-account-dropdown]');
    if (!link) return;

    // Naikkan status ke member; toggle panel diurus wireAccountToggle.
    wrap.setAttribute('data-gk-state', 'member');
    link.href = PORTAL + '/dashboard';

    // Nama depan saja. "Rivaldy" jauh lebih personal daripada "Akun", dan di drawer
    // mobile baris ini yang jadi judul blok akunnya.
    var label = link.querySelector('[data-gk-account-label]');
    if (label) label.textContent = u.name.trim().split(' ')[0];

    // Email dicari dari level wrap, bukan dari panel dropdown. Di header desktop dia
    // memang duduk di dalam panel, tapi di drawer mobile dia naik ke baris profil
    // (di bawah nama) supaya tidak ikut sembunyi waktu dropdown ditutup.
    var emailSlot = wrap.querySelector('[data-gk-account-email]');
    if (emailSlot) {
      if (u.email) { emailSlot.textContent = u.email; emailSlot.hidden = false; }
      else { emailSlot.textContent = ''; emailSlot.hidden = true; }
    }

    var avatarSlot = link.querySelector('[data-gk-account-avatar]');
    if (avatarSlot) {
      if (u.avatarUrl) {
        var img = d.createElement('img');
        img.src = u.avatarUrl;
        img.alt = u.name;
        img.width = 64;
        img.height = 64;
        img.referrerPolicy = 'no-referrer';
        avatarSlot.innerHTML = '';
        avatarSlot.appendChild(img);
      } else {
        avatarSlot.textContent = u.initial;
      }
      avatarSlot.classList.add('is-loaded');
    }

    if (!panel) return;

    renderMenu(panel);

    var nameSlot = panel.querySelector('[data-gk-account-name]');
    if (nameSlot) nameSlot.textContent = u.name;

    var logoutBtn = panel.querySelector('[data-gk-logout]');
    if (logoutBtn && !logoutBtn.hasAttribute('data-gk-wired')) {
      logoutBtn.setAttribute('data-gk-wired', '1');
      logoutBtn.addEventListener('click', function (evt) {
        evt.preventDefault();
        logout();
      });
    }

    // Toggle sudah dipasang wireAccountToggle() untuk semua status; tidak perlu
    // mewire ulang di sini.
  }

  // Tutup dropdown akun (member DAN tamu) kalau klik di luar atau tekan Escape.
  function closeAccountWrap(wrap) {
    wrap.classList.remove('is-open');
    var panels = wrap.querySelectorAll('[data-gk-account-dropdown],[data-gk-account-guest]');
    for (var k = 0; k < panels.length; k++) {
      panels[k].hidden = true;
      panels[k].setAttribute('aria-hidden', 'true');
    }
  }
  d.addEventListener('click', function (e) {
    var openWraps = d.querySelectorAll('[data-gk-account-wrap].is-open');
    for (var i = 0; i < openWraps.length; i++) {
      if (!openWraps[i].contains(e.target)) closeAccountWrap(openWraps[i]);
    }
  });
  d.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var openWraps = d.querySelectorAll('[data-gk-account-wrap].is-open');
    for (var i = 0; i < openWraps.length; i++) closeAccountWrap(openWraps[i]);
  });

  // Gerbang member untuk blok "Keyword buat CV kamu" di halaman job detail.
  // Dijalankan terpisah dari init() di bawah, karena init() berhenti lebih awal
  // kalau payload [data-gk-job] tidak ada atau gagal di-parse -- dan kalau gerbang
  // ini ikut berhenti di situ, member yang sah malah ikut terkunci.
  //
  // Arahnya sengaja fail-CLOSED: HTML datang dalam keadaan terkunci, dan fungsi
  // ini cuma bisa MEMBUKA. Tidak ada cabang yang mengunci ulang, jadi kegagalan
  // apa pun (skrip mati, cookie rusak, Supabase down) berakhir di keadaan
  // terkunci, bukan terbuka.
  //
  // RV-23 (2026-08-06): satu gerbang untuk dua blok. Yang dibuka fungsi ini
  // cuma blok Keyword; blok Analisis tetap dipegang initVisaGate() karena
  // isinya harus diambil dari server dulu.
  //
  // Grid keyword datang DI DALAM kartu gerbang, dalam keadaan buram dan
  // disabled. Fungsi ini MEMINDAHKAN node-nya ke [data-gk-kw-host], bukan
  // menyalinnya: menyalin berarti keyword yang sama ada dua kali di satu
  // halaman, dan salinan yang tertinggal di kartu gerbang akan ikut terbaca
  // pembaca layar walaupun matanya tidak melihat apa-apa.
  // ss2 B1 (2026-09-18): penunjuk "Analisis Get Karier lowongan ini sudah
  // siap" di bawah judul, dikirim `hidden` dari Liquid. Dibuka cuma untuk
  // tamu: member sudah melihat panelnya sendiri, dan ikon gembok salah untuk
  // mereka. Kalau getSession gagal karena jaringan, penunjuk tetap tersembunyi;
  // itu kegagalan ke arah aman (tidak ada yang rusak, cuma tidak ada jalan pintas).
  function initAnPeek() {
    var peek = d.querySelector('[data-gk-anpeek]');
    if (!peek) return;
    getSession().then(function (s) {
      if (!s || !s.access_token) peek.hidden = false;
    }).catch(function () {});
  }

  function initKeywordGate() {
    var gate = d.querySelector('[data-gk-gate]');
    var kwSection = d.querySelector('[data-gk-kw-section]');
    if (!gate) return;

    var loginLink = gate.querySelector('[data-gk-gate-login]');
    if (loginLink) loginLink.href = api.loginUrl(w.location.href.split('#')[0]);

    getSession().then(function (s) {
      if (!s) return;

      var grid = gate.querySelector('[data-gk-kw-content]');
      var host = kwSection ? kwSection.querySelector('[data-gk-kw-host]') : null;
      if (grid && host) {
        host.appendChild(grid);
        // Chip dikirim disabled supaya tab keyboard tidak mendarat di teks
        // buram yang tidak bisa dibaca. Begitu pindah, dia tombol biasa lagi.
        var btns = grid.querySelectorAll('button[disabled]');
        for (var i = 0; i < btns.length; i++) btns[i].removeAttribute('disabled');
      }
      if (kwSection) kwSection.hidden = false;
      gate.hidden = true;
    });
  }

  // Gerbang KERAS blok "Analisis Get Karier" (F-JOB-13, 2026-08-02).
  //
  // Beda mendasar dari initKeywordGate(): di sana teksnya sudah ada di HTML dan
  // fungsi ini cuma membukanya. Di sini teksnya TIDAK ADA di halaman sama
  // sekali. Liquid cuma menulis handle-nya, dan isinya diambil dari edge
  // function jobs-visa-notes yang baru menjawab sesudah memverifikasi sesi.
  //
  // Sebelumnya blok ini pakai gerbang lunak dan itu ternyata cuma gembok di
  // pintu berdinding kaca: seluruh teks ikut terkirim ke semua orang, terbaca
  // lewat Ctrl+U, dan ikut terindeks Google.
  //
  // Tetap fail-CLOSED: HTML datang terkunci, dan satu-satunya jalan membuka
  // adalah balasan 200 dari server. Sesi hilang, jaringan mati, atau EF error
  // semuanya berakhir di keadaan terkunci.
  // ── Analisis Get Karier v1, tampilan v3 (2026-09-18) ────────────────────
  //
  // Diukur di tampilan sebelumnya, dan angka-angka inilah yang mengubah
  // rancangannya: lebar teks di dalam kartu cuma 236 px dari layar 360 px
  // (124 px habis untuk tiga lapis wadah: panel, kartu, isi), sepuluh ukuran
  // huruf, sepuluh warna teks, lima warna latar, dan sembilan label huruf
  // kecil kapital dalam satu panel. Waktu semuanya ditulis "penting", tidak
  // ada yang penting.
  //
  // Yang berubah:
  //   1. Satu bidang, bukan tiga. Bidangnya terang supaya teks panjang enak
  //      dibaca, dan melebar sampai tepi layar di HP.
  //   2. Satu warna aksen per panel, diambil dari tingkat bukti visa, jadi
  //      warnanya membawa arti, bukan hiasan.
  //   3. Kesimpulan di baris teratas, bukan kata "Ringkasnya".
  //   4. Kartu tertutup tetap menjawab lewat satu baris di bawah judulnya.
  //   5. Tangga huruf empat langkah, label kapital maksimal satu per kartu.
  //   6. Gaji dan batas waktu jadi dua ubin berdampingan.
  //
  // Semua teks tetap ditulis lewat textContent. Validator melarang markup di
  // semua nilai, dan menyisipkannya sebagai HTML cuma menambah permukaan
  // serang tanpa memberi apa pun.
  var GKA_IKON = {
    briefcase: 'M16 20V4a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16M4 7h16a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2z',
    building: 'M6 22V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v18ZM10 6h4M10 10h4M10 14h4M10 18h4',
    plane: 'M17.8 19.8 16 14l-4 4v3l-2.5-2.5L6 22l1-4-4 1 3.5-3.5L4 13h3l4-4-5.8-1.8a2 2 0 0 1-.7-3.3l.6-.6a2 2 0 0 1 2.7-.1L22 13l-1.5 5.5a2 2 0 0 1-2.7 1.3z',
    checks: 'M3 7l3 3 5-5M3 17l3 3 5-5M14 8h7M14 18h7',
    chevron: 'm6 9 6 6 6-6',
    check: 'M20 6 9 17l-5-5',
    tanya: 'M22 12a10 10 0 1 1-20 0 10 10 0 0 1 20 0zM9.1 9a3 3 0 0 1 5.8 1c0 2-3 3-3 3M12 17h.01',
    anchor: 'M12 22V8M5 12H2a10 10 0 0 0 20 0h-3M12 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6z',
    // Empat ikon di bawah ditambahkan 19 September 2026 supaya tiap judul
    // vonis punya ikon sendiri. Semuanya digambar dari 24x24, garis 2, sama
    // dengan ikon lain di atas. `plane` sengaja tidak dipakai untuk judul
    // vonis: dia sudah jadi ikon bagian "Visa & izin kerja" tepat di bawahnya.
    petunjuk: 'M21 21l-4.3-4.3M19 11a8 8 0 1 1-16 0 8 8 0 0 1 16 0z',
    tolak: 'M22 12a10 10 0 1 1-20 0 10 10 0 0 1 20 0zM15 9l-6 6M9 9l6 6',
    compass: 'M22 12a10 10 0 1 1-20 0 10 10 0 0 1 20 0zM16.24 7.76l-1.804 5.411a2 2 0 0 1-1.265 1.265L7.76 16.24l1.804-5.411a2 2 0 0 1 1.265-1.265z',
    laptop: 'M20 16V7a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v9m16 0H4m16 0 1.28 2.55a1 1 0 0 1-.9 1.45H3.62a1 1 0 0 1-.9-1.45L4 16'
  };

  // Tingkat bukti menentukan satu warna untuk seluruh panel, dan kalimat
  // kesimpulannya. Nilai `tingkat` datang dari kolom visa_clarity, jadi ini
  // bukan tafsiran baru: cuma cara menampilkan yang sudah tercatat.
  //
  // Judul ditulis ulang 19 September 2026. Sebelumnya `indicated` memakai
  // "Jalurnya jelas, tapi lewat dokumen sendiri" dan ikon jangkar, padahal itu
  // kalimat jalur pelaut: lowongan sponsor biasa yang Terindikasi justru izin
  // kerjanya diajukan perusahaan. `none_stated` juga dulu memakai kalimat
  // "tidak menyebut visa", padahal artinya iklan sudah menjawab dan
  // jawabannya tidak. Tiap judul sekarang punya ikon sendiri.
  var GKA_STATUS = {
    verified:    { warna: 'ya',    ikon: 'check',    judul: 'Perusahaan siap sponsor visa' },
    indicated:   { warna: 'belum', ikon: 'petunjuk', judul: 'Kemungkinan ada sponsor visa' },
    ask:         { warna: 'belum', ikon: 'tanya',    judul: 'Tanpa keterangan visa, kemungkinan masih ada sponsor visa' },
    none_stated: { warna: 'belum', ikon: 'tolak',    judul: 'Iklan menyatakan tanpa sponsor' },
    // `ask` punya dua arti di lowongan-harian: iklannya diam soal visa, ATAU
    // sinyalnya bertentangan. Yang kedua datang bersama `bukti_iklan`, dan
    // kutipan itu tampil tepat di bawah judul. Sampai 3 Oktober 2026 dua-duanya
    // memakai judul "Tanpa keterangan visa", jadi kutipan seperti "Visa
    // support available!" muncul tepat di bawah kalimat yang bilang iklannya
    // tidak menyebut visa (uji satu topik 3 Okt, analisis.md bagian 6 no. 1).
    // Judul ini sengaja tidak bilang "iklan menyebut bantuan visa": dari 73
    // `ask` berkutipan di DB per 3 Okt, kebanyakan kutipannya soal bahasa,
    // lokasi, relokasi, atau hak kerja, bukan janji bantuan visa. Yang benar
    // untuk semuanya cuma bahwa sponsornya belum jelas buat pelamar dari sini.
    ask_kutip:   { warna: 'belum', ikon: 'tanya',    judul: 'Belum jelas ada sponsor visa untuk pelamar dari Indonesia' }
  };
  var GKA_JALUR = {
    pelaut:  { warna: 'jalur', ikon: 'anchor',  judul: 'Jalur pelaut, bukan visa kerja' },
    whv:     { warna: 'jalur', ikon: 'compass', judul: 'Lewat visa working holiday' },
    remote:  { warna: 'jalur', ikon: 'laptop',  judul: 'Remote, tanpa pindah negara' }
  };

  function gkaIkon(nama, kelas) {
    var svg = d.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('aria-hidden', 'true');
    if (kelas) svg.setAttribute('class', kelas);
    var path = d.createElementNS('http://www.w3.org/2000/svg', 'path');
    path.setAttribute('d', GKA_IKON[nama] || GKA_IKON.checks);
    path.setAttribute('fill', 'none');
    path.setAttribute('stroke', 'currentColor');
    // Satu ketebalan garis untuk semua ikon, termasuk chevron accordion.
    // Sebelumnya chevronnya segitiga CSS 2 px di sebelah ikon stroke 2,4 px.
    path.setAttribute('stroke-width', '2');
    path.setAttribute('stroke-linecap', 'round');
    path.setAttribute('stroke-linejoin', 'round');
    svg.appendChild(path);
    return svg;
  }

  function gkaEl(tag, kelas, teks) {
    var el = d.createElement(tag);
    if (kelas) el.className = kelas;
    if (teks != null) el.textContent = teks;
    return el;
  }

  function gkaPotong(teks, batas) {
    teks = String(teks || '').trim();
    if (teks.length <= batas) return teks;
    var potong = teks.slice(0, batas - 1);
    var spasi = potong.lastIndexOf(' ');
    if (spasi > batas * 0.6) potong = potong.slice(0, spasi);
    return potong.replace(/[,.;:]$/, '') + '…';
  }

  // Kartu accordion. `ringkas` tampil di bawah judul waktu kartunya tertutup,
  // supaya kartu tertutup tetap menjawab sesuatu dan orang bisa memutuskan
  // membukanya atau tidak.
  function gkaKartu(id, ikon, judul, ringkas, terbuka) {
    var sec = gkaEl('section', 'gk-an__kartu');
    sec.id = id;
    var tombol = gkaEl('button', 'gk-an__kepala');
    tombol.type = 'button';
    tombol.setAttribute('aria-expanded', terbuka ? 'true' : 'false');
    tombol.setAttribute('aria-controls', id + '-isi');
    tombol.appendChild(gkaIkon(ikon, 'gk-an__ikon'));
    var teks = gkaEl('span', 'gk-an__kepala-teks');
    teks.appendChild(gkaEl('span', 'gk-an__judul', judul));
    if (ringkas) teks.appendChild(gkaEl('span', 'gk-an__ringkas', ringkas));
    tombol.appendChild(teks);
    tombol.appendChild(gkaIkon('chevron', 'gk-an__chev'));
    var isi = gkaEl('div', 'gk-an__isi');
    isi.id = id + '-isi';
    if (!terbuka) isi.hidden = true;
    tombol.addEventListener('click', function () {
      var tutup = isi.hidden;
      isi.hidden = !tutup;
      tombol.setAttribute('aria-expanded', tutup ? 'true' : 'false');
    });
    sec.appendChild(tombol);
    sec.appendChild(isi);
    sec.isi = isi;
    return sec;
  }

  function gkaDaftar(induk, butir) {
    var ul = gkaEl('ul', 'gk-an__list');
    for (var i = 0; i < butir.length; i++) ul.appendChild(gkaEl('li', null, butir[i]));
    induk.appendChild(ul);
  }

  function gkaBarisLabel(induk, baris) {
    var dl = gkaEl('dl', 'gk-an__aturan');
    for (var i = 0; i < baris.length; i++) {
      dl.appendChild(gkaEl('dt', null, baris[i].label));
      dl.appendChild(gkaEl('dd', null, baris[i].nilai));
    }
    induk.appendChild(dl);
  }

  function gkaTanggalPanjang(iso) {
    var BULAN = ['Januari','Februari','Maret','April','Mei','Juni',
                 'Juli','Agustus','September','Oktober','November','Desember'];
    var b = String(iso || '').split('-');
    if (b.length !== 3) return null;
    return Number(b[2]) + ' ' + BULAN[Number(b[1]) - 1] + ' ' + b[0];
  }

  // Sisa hari sampai lowongan tutup. Kalau tanggalnya tidak ada, tidak ditebak
  // dari kolom lain.
  function gkaSisaHari(iso) {
    if (!iso) return null;
    var b = String(iso).split('-');
    if (b.length !== 3) return null;
    var tutup = new Date(Number(b[0]), Number(b[1]) - 1, Number(b[2]));
    var kini = new Date();
    kini.setHours(0, 0, 0, 0);
    var hari = Math.round((tutup - kini) / 86400000);
    if (hari < 0) return { teks: 'Sudah lewat', sub: gkaTanggalPanjang(iso), genting: true };
    if (hari === 0) return { teks: 'Hari terakhir', sub: gkaTanggalPanjang(iso), genting: true };
    return { teks: hari + ' hari lagi', sub: 'sampai ' + gkaTanggalPanjang(iso), genting: hari <= 14 };
  }

  // Nominal pertama di kalimat gaji, persis seperti tertulis (mata uang +
  // angka + "juta/ribu" kalau ada). Tidak dihitung ulang, tidak dibulatkan.
  function gkaNominal(teks) {
    var m = String(teks || '').match(/(?:USD|SGD|MYR|AUD|NZD|EUR|GBP|JPY|HKD|AED|SAR|QAR|CAD|CHF|KRW|TWD|Rp|RM|S\$|A\$|\$|€|£|¥)\s?\d[\d.,]*(?:\s?(?:juta|ribu))?/);
    if (!m) return null;
    var per = /sebulan|per bulan|\/bulan/i.test(teks) ? ' / bulan'
            : /setahun|per tahun|\/tahun/i.test(teks) ? ' / tahun' : '';
    return m[0] + per;
  }
  var GKA_SUMBER_GAJI = { iklan: 'Tertulis di iklan', situs: 'Dari situs gaji', upah_minimum: 'Upah minimum resmi' };

  function gkaUbin(induk, label, nilai, sub, genting) {
    // Nilai yang panjang (misalnya gaji yang datang dari upah minimum resmi
    // berikut padanan rupiahnya) tidak dipaksa tampil sebesar angka pendek;
    // kalau dipaksa, satu ubin jadi dua kali tinggi tetangganya.
    var panjang = String(nilai || '').length > 32;
    var u = gkaEl('div', 'gk-an__ubin' + (genting ? ' is-genting' : '') + (panjang ? ' is-panjang' : ''));
    u.appendChild(gkaEl('span', 'gk-an__ubin-label', label));
    u.appendChild(gkaEl('span', 'gk-an__ubin-nilai', nilai));
    if (sub) u.appendChild(gkaEl('span', 'gk-an__ubin-sub', sub));
    induk.appendChild(u);
  }

  // ss2 v5 (2026-09-18). Panel kembali GELAP penuh: isinya eksklusif member,
  // dan kartu gerbang tamu juga gelap, jadi yang terbuka terasa lanjutan dari
  // yang terkunci (permintaan Rivaldy).
  //
  // Aturan isi v5: panel TIDAK mengulang apa yang sudah terbaca tamu di
  // halaman yang sama. Yang dibuang karena itu:
  //   - chip ringkas (lencana sponsor, lokasi, dan level sudah ada di kepala)
  //   - ubin gaji "tidak disebut" (ada di kotak Gaji sidebar) dan ubin batas
  //     lamar
  //   - pekerjaan.inti (sudah diwakili "Tentang pekerjaan")
  //   - perusahaan.siapa (biasanya parafrase paragraf pembuka iklan asli)
  //   - kicker "Pekerjaan, perusahaan, visa, dan langkahmu" dan label kapital
  //     "Bacaan Get Karier" / "Tertulis di iklan"
  //   - tombol Cek CV (sidebar sudah punya "Cek kesiapan CV kamu")
  // Field-nya tetap ada di data; yang berubah cuma apa yang dirender.
  function gkaBagian(induk, ikon, judul) {
    // <details>: di HP semua bagian mulai tertutup (keputusan Rivaldy 18 Sep,
    // terbuka semua = 3,4 layar); di desktop dibuka sekali waktu render.
    var sec = gkaEl('details', 'gk-an__bagian');
    if (window.matchMedia && window.matchMedia('(min-width: 750px)').matches) sec.open = true;
    var h = gkaEl('summary', 'gk-an__bagian-judul');
    h.appendChild(gkaIkon(ikon, 'gk-an__ikon'));
    h.appendChild(gkaEl('span', 'gk-an__bagian-nama', judul));
    h.appendChild(gkaIkon('chevron', 'gk-an__chev'));
    sec.appendChild(h);
    var isi = gkaEl('div', 'gk-an__bagian-isi');
    sec.appendChild(isi);
    induk.appendChild(sec);
    return isi;
  }

  // Baris aturan yang isinya ambang/upah minimum gampang terbaca sebagai gaji
  // lowongannya. Dikenali dari label, dan diberi catatan eksplisit.
  var GKA_AMBANG = /ambang|upah minimum|gaji minimum|batas gaji/i;

  function gkaBaris(induk, label, nilai, catatan) {
    var r = gkaEl('div', 'gk-an__baris');
    r.appendChild(gkaEl('span', 'gk-an__baris-label', label));
    var v = gkaEl('span', 'gk-an__baris-nilai', nilai);
    r.appendChild(v);
    if (catatan) r.appendChild(gkaEl('span', 'gk-an__baris-catatan', catatan));
    induk.appendChild(r);
  }

  function renderAnalisisV1(content, a, res, job) {
    content.textContent = '';
    var im = a.imigrasi || {};
    var p = a.pekerjaan || {};
    var c = a.perusahaan || {};
    var l = a.langkah || {};
    var st = GKA_JALUR[im.jalur] || GKA_STATUS[im.tingkat] || GKA_STATUS.ask;
    // Kutipan kosong atau cuma spasi diperlakukan sama dengan tidak ada (di DB
    // memang ada `bukti_iklan` berisi string kosong).
    var kutipIklan = im.bukti_iklan ? String(im.bukti_iklan).trim() : '';
    if (st === GKA_STATUS.ask && kutipIklan) st = GKA_STATUS.ask_kutip;

    var akar = gkaEl('div', 'gk-an');
    akar.setAttribute('data-status', st.warna);

    // 1. Vonis + saran. Kutipan iklan hanya kalau ADA: kalau iklannya diam,
    // vonisnya sendiri sudah mengatakan itu.
    var kepala = gkaEl('div', 'gk-an__vonis-baris');
    kepala.appendChild(gkaIkon(st.ikon, 'gk-an__vonis-ikon'));
    kepala.appendChild(gkaEl('p', 'gk-an__vonis', st.judul));
    akar.appendChild(kepala);
    if (a.ringkas && a.ringkas.saran) akar.appendChild(gkaEl('p', 'gk-an__saran', a.ringkas.saran));
    if (kutipIklan) akar.appendChild(gkaEl('blockquote', 'gk-an__kutip', '“' + kutipIklan + '”'));

    // 2. Visa & izin kerja.
    var b1 = gkaBagian(akar, 'plane', 'Visa & izin kerja');
    if (im.bacaan) b1.appendChild(gkaEl('p', 'gk-an__teks', im.bacaan));
    if (im.aturan && im.aturan.length) {
      var rak = gkaEl('div', 'gk-an__rak');
      for (var i = 0; i < im.aturan.length; i++) {
        var at = im.aturan[i];
        // Catatan cuma kalau memang ada angkanya; "Tidak ada ambang" tidak
        // bisa disangka gaji.
        gkaBaris(rak, at.label, at.nilai, GKA_AMBANG.test(at.label) && /\d/.test(at.nilai)
          ? 'Batas minimum supaya izin kerjanya bisa diajukan. Ini bukan gaji lowongan ini.' : null);
      }
      b1.appendChild(rak);
    }
    if (im.wni) b1.appendChild(gkaEl('p', 'gk-an__meta', im.wni));

    // 3. Syarat dan bukti di CV. Patokan gaji hanya kalau ada angkanya (kalau
    // tidak, "tidak dicantumkan" sudah tampil di sidebar).
    var b2 = gkaBagian(akar, 'briefcase', 'Syarat & bukti di CV');
    if (p.cocok_untuk) b2.appendChild(gkaEl('p', 'gk-an__teks', p.cocok_untuk));
    if (p.syarat_kunci && p.syarat_kunci.length) {
      var ulS = gkaEl('ul', 'gk-an__syarat');
      for (var s = 0; s < p.syarat_kunci.length; s++) {
        var li = gkaEl('li');
        li.appendChild(gkaEl('span', 'gk-an__syarat-teks', p.syarat_kunci[s].teks));
        li.appendChild(gkaEl('span', 'gk-an__syarat-cv', p.syarat_kunci[s].bukti_cv));
        ulS.appendChild(li);
      }
      b2.appendChild(ulS);

      // ss2 A1 (2026-09-18): Cek CV tepat sesudah syarat kunci. Ini momen
      // pembaca baru tahu bukti apa yang harus terlihat di CV-nya. Teksnya
      // sengaja tidak menjanjikan "gratis": bonus akun baru memang cukup
      // untuk satu audit hari ini, tapi member lama bisa sudah memakainya.
      var cek = gkaEl('div', 'gk-an__cekcv');
      var jd = gkaEl('p', 'gk-an__cekcv-judul');
      jd.appendChild(gkaIkon('checks', null));
      jd.appendChild(gkaEl('span', null, 'Cek CV-mu terhadap ' + p.syarat_kunci.length + ' syarat di atas'));
      cek.appendChild(jd);
      cek.appendChild(gkaEl('p', 'gk-an__cekcv-sub', 'Audit CV yang dibandingkan langsung dengan iklan lowongan ini.'));
      var cvUrl = 'https://app.getkarier.com/cv-audit?job=' + encodeURIComponent(job.handle || '');
      if (job.title) cvUrl += '&role=' + encodeURIComponent(job.title);
      if (job.country_iso) cvUrl += '&country=' + encodeURIComponent(job.country_iso);
      var btnCv = gkaEl('a', 'gk-an__cekcv-btn', 'Cek CV untuk lowongan ini');
      btnCv.href = cvUrl;
      cek.appendChild(btnCv);
      b2.appendChild(cek);
    }
    var gj = p.gaji;
    if (gj && gj.teks && gj.sumber && gj.sumber !== 'tidak_ada') {
      var rakG = gkaEl('div', 'gk-an__rak');
      gkaBaris(rakG, gj.sumber === 'iklan' ? 'Gaji di iklan' : 'Patokan gaji', gj.teks,
        gj.sumber === 'iklan' ? null : 'Angka pembanding dari luar iklan, bukan gaji yang ditawarkan lowongan ini.');
      b2.appendChild(rakG);
    }

    // 4. Perusahaan: fakta dan sikapnya soal pekerja asing.
    if ((c.fakta && c.fakta.length) || (c.sikap_visa && c.sikap_visa.teks)) {
      var b3 = gkaBagian(akar, 'building', 'Perusahaan');
      if (c.fakta && c.fakta.length) gkaDaftar(b3, c.fakta);
      if (c.sikap_visa && c.sikap_visa.teks) b3.appendChild(gkaEl('p', 'gk-an__teks', c.sikap_visa.teks));
    }

    // 5. Pelatihan dulu, lalu skill, lalu urutan langkah. `langkah.pelatihan`
    // itu field BARU (usulan skema v1.1): [{judul, penyedia, biaya:
    // "gratis"|"berbayar", harga?, url, dicek, skill?}]. Tanpa data, blok ini
    // tidak muncul; tidak ada pelatihan yang ditebak di sini.
    var b4 = gkaBagian(akar, 'checks', 'Pelatihan & langkah');
    if (l.pelatihan && l.pelatihan.length) {
      var ulP = gkaEl('ul', 'gk-an__latih');
      for (var t = 0; t < l.pelatihan.length; t++) {
        var pl = l.pelatihan[t];
        var liP = gkaEl('li');
        var aP = gkaEl('a', 'gk-an__latih-judul', pl.judul);
        aP.href = pl.url; aP.target = '_blank'; aP.rel = 'noopener nofollow';
        liP.appendChild(aP);
        var meta = gkaEl('span', 'gk-an__latih-meta');
        meta.appendChild(gkaEl('span', 'gk-an__latih-biaya' + (pl.biaya === 'gratis' ? ' is-gratis' : ''),
          pl.harga || (pl.biaya === 'gratis' ? 'Gratis' : 'Berbayar')));
        meta.appendChild(document.createTextNode(pl.penyedia + (pl.skill ? ' · ' + pl.skill : '')));
        liP.appendChild(meta);
        ulP.appendChild(liP);
      }
      b4.appendChild(ulP);
    }
    if (l.skill && l.skill.length) {
      var ulK = gkaEl('ul', 'gk-an__syarat');
      for (var k = 0; k < l.skill.length; k++) {
        var liK = gkaEl('li');
        liK.appendChild(gkaEl('span', 'gk-an__syarat-teks', l.skill[k].nama));
        liK.appendChild(gkaEl('span', 'gk-an__syarat-cv', l.skill[k].kenapa));
        ulK.appendChild(liK);
      }
      b4.appendChild(ulK);
    }
    if (l.urutan && l.urutan.length) {
      var ol = gkaEl('ol', 'gk-an__urutan');
      for (var u = 0; u < l.urutan.length; u++) ol.appendChild(gkaEl('li', null, l.urutan[u]));
      b4.appendChild(ol);
    }

    // 6. Career Map (satu-satunya tombol) dan sumber.
    var kaki = gkaEl('div', 'gk-an__kaki');
    if (job.country_iso) {
      var b2t = gkaEl('a', 'gk-an__peta', 'Buka Career Map' + (job.country ? ' ' + job.country : '') + ' →');
      b2t.href = 'https://app.getkarier.com/career-map?negara=' +
                 encodeURIComponent(String(job.country_iso).toLowerCase());
      kaki.appendChild(b2t);
    }
    if (a.sumber && a.sumber.length) {
      var det = gkaEl('details', 'gk-an__sumber');
      var tgl = gkaTanggalPanjang(a.ditulis);
      det.appendChild(gkaEl('summary', null,
        a.sumber.length + ' sumber' + (tgl ? ', ditulis ' + tgl : '')));
      var ulSum = gkaEl('ul');
      for (var m = 0; m < a.sumber.length; m++) {
        var liS = gkaEl('li');
        var aS = gkaEl('a', null, a.sumber[m].judul);
        aS.href = a.sumber[m].url; aS.target = '_blank'; aS.rel = 'noopener nofollow';
        liS.appendChild(aS);
        var tglS = gkaTanggalPanjang(a.sumber[m].dicek);
        if (tglS) liS.appendChild(gkaEl('span', 'gk-an__dicek', 'dicek ' + tglS));
        ulSum.appendChild(liS);
      }
      det.appendChild(ulSum);
      det.appendChild(gkaEl('p', 'gk-an__meta',
        'Angka di panel ini diambil dari sumber di atas pada tanggal yang tertulis, dan aturan negara bisa berubah sesudahnya.'));
      kaki.appendChild(det);
    }
    akar.appendChild(kaki);

    content.appendChild(akar);
  }

  function initVisaGate() {
    var wrap = d.querySelector('[data-gk-visa-handle]');
    if (!wrap) return;

    var lock = wrap.querySelector('[data-gk-visa-lock]');
    var content = wrap.querySelector('[data-gk-visa-content]');
    var handle = wrap.getAttribute('data-gk-visa-handle');
    if (!handle || !content) return;

    // RV-23: panelnya sendiri sekarang dikirim `hidden`, dan anonim diwakili
    // kartu gerbang gabungan. Jadi ada dua keadaan yang boleh membukanya, dan
    // dua-duanya cuma bisa dicapai sesudah sesi terbukti ada:
    //   - analisisnya datang  -> panel + isi
    //   - pengambilannya gagal -> panel + kartu "belum bisa dimuat"
    // Anonim tidak pernah masuk ke salah satunya, jadi tidak ada teks apa pun
    // yang bocor lewat cabang gagal. Gerbang kerasnya utuh.
    // `authed` bukan hiasan. Tanpa dia, getSession() yang gagal karena
    // jaringan akan jatuh ke catch dan membuka panel untuk ANONIM juga.
    var authed = false;
    function fail() {
      if (!authed) return;
      wrap.hidden = false;
      if (lock) lock.hidden = false;
    }

    getSession().then(function (s) {
      if (!s || !s.access_token) return;
      authed = true;
      // 🔴 BUKAN `BASE`. Ini satu-satunya panggilan di file ini yang keluar
      // dari project member portal.
      //
      // `BASE` itu project member portal, tempat sesi diterbitkan. Tapi
      // `jobs-visa-notes` hidup di project JOB PORTAL, karena di situlah RPC
      // token Shopify berada. Sampai 4 Agustus 2026 baris ini memakai `BASE`,
      // jadi panggilannya mendarat di project yang tidak punya fungsi itu:
      // balasannya gagal di tingkat jaringan (responseStatus 0, bukan 401),
      // dan karena gerbangnya fail-closed, SEMUA member melihat kartu "daftar
      // gratis" sejak gerbang keras dipasang 2 Agustus.
      // ss2 (2026-09-17): jobs-analisis dulu, jobs-visa-notes sebagai jaring.
      //
      // Balasan jobs-analisis membawa dua-duanya sekaligus (`analisis` versi
      // baru dan `lama` berisi visa_notes), jadi lowongan yang belum diisi
      // analisis v1 tetap dapat panel lama tanpa panggilan jaringan kedua.
      // Kalau EF barunya sendiri yang gagal, baru jatuh ke EF lama; itu yang
      // membuat pemasangan ini tidak pernah bisa mengosongkan panel yang
      // sekarang sudah tayang.
      var kepala = { headers: { Authorization: 'Bearer ' + s.access_token } };
      return fetch(
        JOBS_BASE + '/functions/v1/jobs-analisis?handle=' + encodeURIComponent(handle), kepala
      ).then(function (r) {
        return r.ok ? r.json() : null;
      }).catch(function () {
        return null;
      }).then(function (res) {
        if (res && res.ok && res.analisis) {
          var jobEl = d.querySelector('[data-gk-job]');
          var job = {};
          if (jobEl) { try { job = JSON.parse(jobEl.textContent) || {}; } catch (e) { job = {}; } }
          renderAnalisisV1(content, res.analisis, res, job);
          // v5: panel tetap gelap penuh. Kicker disembunyikan: isinya cuma
          // mengulang judul bagian di bawahnya.
          wrap.classList.add('is-v1');
          var kicker = wrap.querySelector('.gk-jobsection__kicker');
          if (kicker) kicker.hidden = true;
          content.hidden = false;
          if (lock) lock.hidden = true;
          wrap.hidden = false;
          return;
        }
        // Belum ada analisis v1: pakai teks lama yang ikut dikirim EF baru,
        // dan kalau EF barunya gagal sama sekali, ambil dari EF lama.
        if (res && res.ok && res.lama && (res.lama.paragraf || []).length) {
          return renderLama(res, res.lama.paragraf);
        }
        return fetch(
          JOBS_BASE + '/functions/v1/jobs-visa-notes?handle=' + encodeURIComponent(handle), kepala
        ).then(function (r2) {
          return r2.ok ? r2.json() : null;
        }).then(function (res2) {
          if (!res2 || !res2.ok) return fail();
          var par2 = res2.paragraf || [];
          if (!par2.length) return fail();
          return renderLama(res2, par2);
        });
      });
    }).catch(function () {
      fail();
    });

    function renderLama(res, par) {

        // Ditulis lewat textContent per paragraf, bukan innerHTML. Isinya teks
        // yang ditulis pipeline dan tidak pernah memuat markup, jadi
        // menyisipkannya sebagai HTML cuma menambah permukaan serang tanpa
        // memberi apa pun.
        content.textContent = '';

        // ── Bukti dipisah dari tafsiran, 2026-09-05 ────────────────────────
        //
        // Sampai hari ini blok ini satu dinding teks: kutipan dari iklan dan
        // bacaan Get Karier lebur jadi satu, dan pembaca tidak punya cara
        // membedakan mana yang benar-benar tertulis di iklannya dan mana yang
        // kesimpulan kami. Diukur di 1.617 analisis yang tayang: cuma 9,5%
        // memuat kutipan harfiah sama sekali.
        //
        // Sekarang kutipannya punya blok sendiri di ATAS bacaan kami, dengan
        // label yang menyebut sumbernya. Urutannya sengaja begitu: yang bisa
        // diperiksa pembaca datang lebih dulu, penilaian kami menyusul.
        //
        // 🔴 Kutipan KOSONG bukan kegagalan, dan tidak boleh disembunyikan.
        // Banyak iklan memang tidak menyebut visa sama sekali, dan itu fakta
        // yang menentukan. Kalau bloknya cuma muncul waktu ada kutipan,
        // pembaca tidak pernah tahu bedanya "iklannya diam" dari "kami belum
        // mengutipnya".
        var kutipan = res.kutipan;
        var qWrap = d.createElement('div');
        qWrap.className = 'gk-visa__evidence';
        var qLabel = d.createElement('p');
        qLabel.className = 'gk-visa__evidence-label';
        qLabel.textContent = 'Yang tertulis di iklan';
        qWrap.appendChild(qLabel);
        var qText = d.createElement('p');
        if (kutipan) {
          qText.className = 'gk-visa__evidence-quote';
          qText.textContent = '\u201C' + kutipan + '\u201D';
        } else {
          qText.className = 'gk-visa__evidence-kosong';
          qText.textContent = 'Iklan ini tidak menyebut visa, izin kerja, maupun sponsorship.';
        }
        qWrap.appendChild(qText);
        content.appendChild(qWrap);

        var bLabel = d.createElement('p');
        bLabel.className = 'gk-visa__evidence-label';
        bLabel.textContent = 'Bacaan Get Karier';
        content.appendChild(bLabel);

        for (var i = 0; i < par.length; i++) {
          var p = d.createElement('p');
          p.textContent = par[i];
          content.appendChild(p);
        }

        // ── Asal-usul analisisnya ─────────────────────────────────────────
        //
        // Dua hal yang sebelumnya tidak pernah diberitahukan ke pembaca: kapan
        // analisisnya ditulis, dan dari mana. Iklan berubah, analisisnya tidak
        // ditinjau ulang, dan sampai hari ini tidak ada satu pun tanda umur di
        // halaman.
        //
        // Tanggalnya cuma ditampilkan kalau memang tercatat. Baris sebelum
        // 2026-09-05 tidak punya, dan menebaknya dari kolom lain berarti
        // memajang tanggal palsu di blok yang justru sedang dibenahi
        // kejujurannya. Tautan iklan aslinya tetap ditampilkan untuk semua,
        // karena itu berlaku benar tanpa perlu menebak apa pun.
        var jejak = d.createElement('p');
        jejak.className = 'gk-visa__jejak';
        var kalimat = 'Analisis ini disusun dari teks iklan aslinya';
        if (res.analisis_pada) {
          var BULAN = ['Januari','Februari','Maret','April','Mei','Juni',
                       'Juli','Agustus','September','Oktober','November','Desember'];
          var bagian = String(res.analisis_pada).split('-');
          if (bagian.length === 3) {
            kalimat += ', ditulis ' + Number(bagian[2]) + ' ' +
                       BULAN[Number(bagian[1]) - 1] + ' ' + bagian[0];
          }
        }
        jejak.textContent = kalimat + '.';
        if (res.sumber_url) {
          jejak.appendChild(d.createTextNode(' '));
          var a = d.createElement('a');
          a.href = res.sumber_url;
          a.target = '_blank';
          a.rel = 'noopener nofollow';
          a.className = 'gk-visa__jejak-link';
          a.textContent = 'Buka iklan aslinya';
          jejak.appendChild(a);
        }
        content.appendChild(jejak);

      content.hidden = false;
      if (lock) lock.hidden = true;
      wrap.hidden = false;
    }
  }

  // Wiring halaman job detail: payload dari <script type="application/json" data-gk-job>
  function init() {
    var dataEl = d.querySelector('[data-gk-job]');
    if (!dataEl) return;
    var job;
    try { job = JSON.parse(dataEl.textContent); } catch (e) { return; }
    if (!job || !job.handle) return;

    var saveBtn = d.querySelector('[data-gk-save]');
    var saveLabel = d.querySelector('[data-gk-save-label]');
    var loginBox = d.querySelector('[data-gk-login]');
    var loginLink = d.querySelector('[data-gk-login-link]');
    var applyBtn = d.querySelector('[data-gk-apply]');
    var saved = false;
    var busy = false;

    function paint() {
      if (!saveBtn) return;
      saveBtn.setAttribute('aria-pressed', saved ? 'true' : 'false');
      saveBtn.classList.toggle('is-saved', saved);
      if (saveLabel) saveLabel.textContent = saved ? 'Tersimpan' : 'Simpan lowongan';
    }

    if (loginLink) {
      var back = w.location.href.split('#')[0];
      back += (back.indexOf('?') > -1 ? '&' : '?') + 'gk_save=1';
      loginLink.href = api.loginUrl(back);
    }

    // L4: klik Lamar dari orang yang BELUM login dulu berakhir di
    // `if (!s) return` di dalam trackApply(), jadi tidak ada jejak apa pun,
    // di sisi kami maupun di sisi dia.
    //
    // Sekarang satu klik menjawab dua keadaan, dan sengaja lewat SATU
    // getSession(): kalau trackApply() dipanggil lalu getSession() dipanggil
    // lagi di sini, dua permintaan berangkat untuk satu pertanyaan yang sama,
    // dan yang kedua bisa menjawab beda kalau tokennya kebetulan disegarkan di
    // antaranya.
    //
    // Kartunya dibuka SESUDAH klik, bukan sebelum. Orang yang baru menekan
    // Lamar sedang di niat paling tinggi yang pernah dia punya di halaman ini;
    // orang yang belum menekannya belum punya lamaran untuk dicatat.
    if (applyBtn) {
      var afterBox = d.querySelector('[data-gk-after-apply]');
      var afterLink = d.querySelector('[data-gk-after-link]');

      if (afterLink) {
        // Dibawa balik ke halaman ini, dengan penanda yang sama dengan tombol
        // Simpan (gk_save=1) supaya sesudah login lowongannya ikut tersimpan.
        // Orang yang sudah repot login karena baru melamar tidak boleh disuruh
        // mencari ulang lowongan yang tadi.
        var kembali = w.location.href.split('#')[0];
        kembali += (kembali.indexOf('?') > -1 ? '&' : '?') + 'gk_save=1';
        afterLink.href = api.loginUrl(kembali);
      }

      applyBtn.addEventListener('click', function () {
        getSession().then(function (s) {
          if (s) {
            api.trackApplyWithSession(s, job);
            return;
          }
          if (afterBox) afterBox.hidden = false;
        }).catch(function () {
          // Gagal memeriksa sesi bukan alasan menyembunyikan tawarannya.
          // Yang paling buruk yang bisa terjadi: member yang sudah login
          // melihat satu kartu yang tidak dia butuhkan. Yang lebih buruk dari
          // itu: pengunjung yang belum login tidak melihat apa pun karena
          // jaringannya sedang batuk.
          if (afterBox) afterBox.hidden = false;
        });
      });
    }

    if (saveBtn) {
      saveBtn.addEventListener('click', function () {
        if (busy) return;
        busy = true;
        getSession().then(function (s) {
          if (!s) {
            busy = false;
            if (loginBox) loginBox.hidden = false;
            // Pop-up Gerbang 'job_simpan_anon': loginBox inline di atas cuma
            // bilang lowongannya aman lintas perangkat, tidak pernah menyebut
            // Miles. Pop-up ini nambahin angka yang loginBox-nya tidak sebut
            // (akun baru = 200 Miles = satu Audit CV penuh), sekali per
            // browser sampai orangnya login.
            if (w.gkPopup && w.gkPopup.bolehTampil('job_simpan_anon', { maxShows: 1 })) {
              w.gkPopup.tandaiTampil('job_simpan_anon');
              w.gkPopup.buka({
                kind: 'gerbang',
                eyebrow: 'SIMPAN LOWONGAN',
                judul: 'Simpan lowongan untuk dilihat lagi',
                isi: [
                  'Simpan lowongan ini ke daftar tersimpan di portal Get Karier. Kamu bisa membukanya lagi saat siap melamar.',
                  'Buat akun gratis untuk menyimpan lowongan lintas perangkat. Akun baru menerima 200 Miles; penggunaan Miles mengikuti aturan di Paspor Karier.'
                ],
                imageUrl: 'https://app.getkarier.com/popups/job_simpan_anon.webp',
                bgColor: '#FAF6EF',
                primary: { label: 'Masuk untuk simpan lowongan', href: loginLink ? loginLink.href : PORTAL },
                secondaryLabel: 'Nanti saja'
              });
            }
            return;
          }
          var act = saved ? api.unsave(job.handle) : api.save(job);
          act.then(function (ok) {
            if (ok) { saved = !saved; paint(); }
            busy = false;
          });
        });
      });
    }

    getSession().then(function (s) {
      if (!s) return;
      api.isSaved(job.handle).then(function (yes) {
        saved = !!yes;
        var wantSave = /[?&]gk_save=1/.test(w.location.search);
        if (!saved && wantSave) {
          api.save(job).then(function (ok) { if (ok) { saved = true; paint(); } });
        }
        paint();
        if (wantSave && w.history && w.history.replaceState) {
          var clean = w.location.href.replace(/([?&])gk_save=1&?/, '$1').replace(/[?&]$/, '');
          w.history.replaceState(null, '', clean);
        }
      });
    });
  }

  // ── Saldo Miles di header (Paspor Karier, permukaan keempat) ────────
  //
  // Portal, Career Map, dan CV Auditor memanggil /api/miles karena ketiganya
  // satu origin dengan portal. Storefront beda origin dan endpoint itu memang
  // tidak melayani CORS, tapi ternyata CORS tidak dibutuhkan sama sekali:
  // cookie sesi ber-domain .getkarier.com sudah terbaca di file ini, dan
  // Supabase melayani CORS-nya sendiri. Jadi jalannya sama persis dengan
  // saved_jobs dan apply_clicks, bukan mekanisme baru.
  //
  // 🔴 Sengaja HANYA saldo, TANPA toast "cap baru masuk". Toast di portal
  // memakai gk_miles_pop_unseen() yang MENGHAPUS antrean pengumuman begitu
  // dipanggil. Kalau halaman ini ikut memanggilnya tanpa menggambar toast,
  // capnya tetap didapat orangnya tapi perayaannya hilang diam-diam, dan itu
  // kegagalan yang tidak meninggalkan jejak apa pun.
  //
  // Fail-open sepenuhnya: kalau sesi tidak ada atau RPC gagal, barisnya tidak
  // muncul dan header tetap seperti sekarang.
  //
  // MILES_CSS dan seluruh pembuatan .gk-miles-pill dihapus 2026-07-31 bareng
  // F-LP-18. Yang tersisa cuma baris dropdown, dan CSS-nya sudah ada di
  // gk-account-menu.css, jadi tidak ada lagi style yang perlu disuntik dari JS.
  //
  // Pil Miles pesawat di header DICABUT 2026-07-31 (F-LP-18). Saldo sekarang
  // cuma hidup di baris dropdown akun, sebaris di bawah foto profil, dengan
  // format maskapai "635 Miles · Economy".
  //
  // Pil itu sudah desktop-only sejak 27 Juli (min-width: 1025px), jadi di HP
  // dropdown memang sudah satu-satunya rumah saldo. Perubahan ini menyamakan
  // desktop dengan mobile, bukan memindahkan sesuatu yang baru.
  //
  // Nama level diambil dari RPC gk_miles_level, TIDAK ditebak dari saldo.
  // Levelnya dihitung dari Miles KUALIFIKASI (gk_miles_qualifying), yang bukan
  // angka yang sama dengan saldo: saldo turun waktu Miles dipakai, kualifikasi
  // tidak. Menebak level dari saldo akan menurunkan level orang begitu dia
  // belanja, dan itu kebalikan dari maksud programnya. Kalau RPC-nya gagal,
  // yang tampil angkanya saja tanpa level, bukan level yang salah.
  function initMiles() {
    var wraps = d.querySelectorAll('[data-gk-account-wrap]');
    if (!wraps.length) return;

    api.rpc('gk_miles_state').then(function (m) {
      if (!m || m.authed !== true) return;

      var n = Number(m.balance || 0);
      var teks;
      try { teks = new Intl.NumberFormat('id-ID').format(n); } catch (e) { teks = String(n); }

      return api.rpc('gk_miles_level')
        .catch(function () { return null; })
        .then(function (lv) {
          var kelas = lv && lv.authed === true && lv.level_name ? lv.level_name : null;
          var kunci = lv && lv.level_key ? lv.level_key : '';
          // Economy akhirnya punya emblem sendiri (ss27, Sesi B). Sebelum itu
          // kelas terbawah tampil tanpa gambar sama sekali, dan itu terbaca
          // seperti kelas yang belum jadi, bukan kelas yang memang paling awal.
          var EMBLEM = {
            economy: CONF.emblemEconomy || '',
            business: CONF.emblemBusiness || '',
            first_class: CONF.emblemFirstClass || ''
          };

          // ss20: kartu Miles (S-A). Saldo, kelas + emblem, dan bar kemajuan
          // ke kelas berikutnya. Yang tidak diketahui dibiarkan kosong, bukan
          // ditebak: kelas yang salah lebih buruk daripada kelas yang tidak
          // disebut (alasan sama dengan komentar di atas initMiles).
          for (var j = 0; j < wraps.length; j++) {
            var row = wraps[j].querySelector('[data-gk-account-miles]');
            if (!row) continue;
            var valueSlot = row.querySelector('[data-gk-account-miles-value]');
            if (valueSlot) valueSlot.textContent = teks;

            var kelasSlot = row.querySelector('[data-gk-tiket-kelas]');
            if (kelasSlot) {
              if (kelas) {
                var emb = EMBLEM[kunci];
                kelasSlot.innerHTML = (emb ? '<img src="' + emb + '" alt="" width="26" height="26">' : '') +
                  '<span>' + kelas + '</span>';
              } else {
                kelasSlot.textContent = 'Miles';
              }
            }

            // 26 Sep 2026: bar kemajuan + "X Miles Kualifikasi lagi ke Y"
            // dicabut dari menu akun (baris Miles jadi satu baris). Detail
            // kemajuan kelas tetap di /paspor portal.

            row.setAttribute('aria-label', teks + ' Miles' + (kelas ? ' · ' + kelas : ''));
            row.hidden = false;
          }
        });
    });
  }

  // ss17 (17 Sep 2026): penanda "Kamu di sini" di kartu kelas halaman Miles.
  // Kelasnya dari RPC gk_miles_level, sumber yang sama dengan kartu Miles di
  // menu akun dan dengan portal; TIDAK ditebak dari saldo (lihat komentar
  // panjang di atas initMiles). Tamu dan RPC yang gagal berarti tidak ada
  // penanda sama sekali, bukan penanda di kelas yang salah.
  function initKelas() {
    var kartu = d.querySelectorAll('[data-gk-kelas-key]');
    if (!kartu.length) return;
    api.rpc('gk_miles_level').then(function (lv) {
      if (!lv || lv.authed !== true || !lv.level_key) return;
      for (var i = 0; i < kartu.length; i++) {
        if (kartu[i].getAttribute('data-gk-kelas-key') !== lv.level_key) continue;
        kartu[i].classList.add('is-kamu');
        var chip = kartu[i].querySelector('[data-gk-kelas-disini]');
        if (chip) chip.hidden = false;
      }
      var stop = d.querySelector('[data-gk-kelas-stop="' + lv.level_key + '"]');
      if (stop) stop.classList.add('is-kamu');
    });
  }

  // Elemen bertanda data-gk-guest-only cuma untuk yang BELUM login. Sekarang
  // dipakai pita "Bikin akun gratis, langsung dapat 200 Miles" di halaman
  // daftar lowongan (F-JOB-02): mengajak orang yang sudah punya akun untuk
  // bikin akun itu membuang satu baris penuh di layar pertama.
  //
  // Disembunyikan lewat class, bukan atribut hidden, karena pitanya
  // display:flex dan itu menang lawan hidden.
  function initGuestOnly() {
    var els = d.querySelectorAll('[data-gk-guest-only]');
    if (!els.length) return;
    getSession().then(function (s) {
      if (!s) return;
      for (var i = 0; i < els.length; i++) els[i].classList.add('is-hidden');
    });
  }

  // Pop-up Offer 'keranjang_ditinggal'. Beda dari pop-up lain di file ini:
  // ini murni dari /cart.js Shopify, tidak butuh sesi Supabase sama sekali,
  // jadi jalan untuk siapa pun termasuk yang belum pernah login.
  //
  // Dokumen audit menulis syaratnya "kembali dalam 7 hari dengan keranjang
  // berisi". Shopify tidak punya cara murah untuk tahu "orang ini PERGI lalu
  // KEMBALI" tanpa backend sesi sendiri, jadi dipakai proxy: kalau keranjang
  // sudah terlihat berisi >=1 jam yang lalu (localStorage) dan masih berisi
  // sekarang, anggap itu kunjungan kembali. Sengaja tidak tampil di
  // penampakan PERTAMA supaya tidak mengganggu orang yang masih belanja aktif.
  var CART_FIRST_SEEN_KEY = 'gk_cart_pertama_terlihat';
  var CART_JEDA_MS = 60 * 60 * 1000;

  function initKeranjangDitinggal() {
    if (!w.gkPopup) return;
    // Sudah di halaman keranjang: mengajak "lanjut ke keranjang" di situ juga tidak masuk akal.
    if (/^\/cart\b/.test(w.location.pathname)) return;
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (!cart) return;
        if (!cart.item_count) {
          try { localStorage.removeItem(CART_FIRST_SEEN_KEY); } catch (e) {}
          return;
        }

        var firstSeen = null;
        try { firstSeen = localStorage.getItem(CART_FIRST_SEEN_KEY); } catch (e) {}
        if (!firstSeen) {
          try { localStorage.setItem(CART_FIRST_SEEN_KEY, String(Date.now())); } catch (e) {}
          return; // kunjungan pertama melihat keranjang berisi, belum layak diingatkan
        }
        if (Date.now() - Number(firstSeen) < CART_JEDA_MS) return;
        if (!w.gkPopup.bolehTampil('keranjang_ditinggal', { cooldownDays: 14 })) return;

        var nama = (cart.items && cart.items[0] && cart.items[0].product_title) || 'Barang kamu';
        w.gkPopup.tandaiTampil('keranjang_ditinggal');
        w.gkPopup.buka({
          kind: 'offer',
          eyebrow: 'KERANJANGMU',
          judul: 'Masih ada produk di keranjangmu',
          isi: [
            nama + ' masih ada di keranjangmu. Buka keranjang untuk meninjau isi dan totalnya sebelum lanjut.',
            'Kamu bisa melanjutkan checkout sekarang atau kembali nanti saat sudah siap.'
          ],
          imageUrl: 'https://app.getkarier.com/popups/keranjang_ditinggal.webp',
          bgColor: '#FAF6EF',
          primary: { label: 'Lanjut ke keranjang', href: '/cart' },
          secondaryLabel: 'Nanti saja'
        });
      })
      .catch(function () {});
  }

  function initAll() {
    initAccountLinks();
    initAnPeek();
    initKeywordGate();
    initVisaGate();
    initMiles();
    initKelas();
    initGuestOnly();
    initKeranjangDitinggal();
    init();
  }

  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', initAll);
  else initAll();
})(window, document);
